"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.findBy = exports.find = exports.register = exports.EVoyageSystemType = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageSystems_bed_sidecar_1 = require("@voyage/systems/voyageSystems_bed-sidecar");
var voyageSystems_coffeeMaker_sidecar_1 = require("@voyage/systems/voyageSystems_coffeeMaker-sidecar");
var voyageSystems_coms_sidecar_1 = require("@voyage/systems/voyageSystems_coms-sidecar");
var voyageSystems_crematorium_sidecar_1 = require("@voyage/systems/voyageSystems_crematorium-sidecar");
var voyageSystems_cryo_sidecar_1 = require("@voyage/systems/voyageSystems_cryo-sidecar");
var voyageSystems_ejector_sidecar_1 = require("@voyage/systems/voyageSystems_ejector-sidecar");
var voyageSystems_ejectrol_sidecar_1 = require("@voyage/systems/voyageSystems_ejectrol-sidecar");
var voyageSystems_externalSensor_sidecar_1 = require("@voyage/systems/voyageSystems_externalSensor-sidecar");
var voyageSystems_hyperdrive_sidecar_1 = require("@voyage/systems/voyageSystems_hyperdrive-sidecar");
var voyageSystems_internalSensor_sidecar_1 = require("@voyage/systems/voyageSystems_internalSensor-sidecar");
var voyageSystems_laser_sidecar_1 = require("@voyage/systems/voyageSystems_laser-sidecar");
var voyageSystems_lifeSupport_sidecar_1 = require("@voyage/systems/voyageSystems_lifeSupport-sidecar");
var voyageSystems_med_sidecar_1 = require("@voyage/systems/voyageSystems_med-sidecar");
var voyageSystems_medPad_sidecar_1 = require("@voyage/systems/voyageSystems_medPad-sidecar");
var voyageSystems_nav_sidecar_1 = require("@voyage/systems/voyageSystems_nav-sidecar");
var voyageSystems_rack_sidecar_1 = require("@voyage/systems/voyageSystems_rack-sidecar");
var voyageSystems_reactor_sidecar_1 = require("@voyage/systems/voyageSystems_reactor-sidecar");
var voyageSystems_torpedo_sidecar_1 = require("@voyage/systems/voyageSystems_torpedo-sidecar");
var voyageSystems_torpedoLoader_sidecar_1 = require("@voyage/systems/voyageSystems_torpedoLoader-sidecar");
var voyageTileData_1 = require("@voyage/tilemap/voyageTileData");
var EVoyageSystemType;
(function (EVoyageSystemType) {
    EVoyageSystemType[EVoyageSystemType["Null"] = 0] = "Null";
    EVoyageSystemType[EVoyageSystemType["NotMarked"] = 1] = "NotMarked";
    EVoyageSystemType[EVoyageSystemType["Nav"] = 2] = "Nav";
    EVoyageSystemType[EVoyageSystemType["SensorInternal"] = 3] = "SensorInternal";
    EVoyageSystemType[EVoyageSystemType["SensorExternal"] = 4] = "SensorExternal";
    EVoyageSystemType[EVoyageSystemType["Coms"] = 5] = "Coms";
    EVoyageSystemType[EVoyageSystemType["TorpedoLoader"] = 6] = "TorpedoLoader";
    EVoyageSystemType[EVoyageSystemType["LifeSupport"] = 7] = "LifeSupport";
    EVoyageSystemType[EVoyageSystemType["Reactor"] = 8] = "Reactor";
    EVoyageSystemType[EVoyageSystemType["JumpDrive"] = 9] = "JumpDrive";
})(EVoyageSystemType = exports.EVoyageSystemType || (exports.EVoyageSystemType = {}));
var _default = {
    type: EVoyageSystemType.NotMarked,
    name: 'Default',
    startsWith: 'default',
    tileType: voyageTileData_1.EVoyageTile.System,
    onCreate: function () { },
    crewUpdate: function () { },
    onSelectedCrewOn: function () { },
    startsWithAmmo: 0,
    abbv: '',
    abbvXAdjust: 0,
    infoText: '',
    frozenCrewName: '',
    allowMultiple: false,
    frame: null,
    killText: false,
    killImage: false,
    hide: false,
    tint: 0xffffff,
};
var dataList = [];
function register(data) {
    var d = Object.assign({}, _default, data);
    dataList.push(d);
    return d;
}
exports.register = register;
function find(tile) {
    return findBy(tile.tile3.type, tile.text3);
}
exports.find = find;
function findBy(tileType, text3) {
    for (var i = 0; i < dataList.length; i++) {
        var c = dataList[i];
        if (c.tileType !== tileType) {
            continue;
        }
        if (c.startsWith) {
            if (!text3.startsWith(c.startsWith)) {
                continue;
            }
        }
        return c;
    }
    return _default;
}
exports.findBy = findBy;
function registerAll() {
    register({
        startsWith: 'null',
        name: 'Null',
    });
    register({
        startsWith: 'cryo',
        onCreate: voyageSystems_cryo_sidecar_1.voyageSystems_cryo.onCreate,
        crewUpdate: voyageSystems_cryo_sidecar_1.voyageSystems_cryo.crewUpdate,
        startsWithAmmo: 1,
        abbv: 'Y',
        name: 'Cryo Freezing Station',
        infoText: 'Often contains emergency additional crew in a popsicle state.',
        extraInfo: function (t) {
            if (t.system) {
                if (t.system.ammo === 0) {
                    return 'Is currently empty';
                }
                if (t.system.ammo === 1) {
                    return 'Contains ' + t.system.frozenCrewName;
                }
            }
            return '?';
        },
    });
    register({
        type: EVoyageSystemType.SensorInternal,
        startsWith: 'sensor-internal',
        crewUpdate: voyageSystems_internalSensor_sidecar_1.voyageSystems_internalSensor.crewUpdate,
        onLeave: voyageSystems_internalSensor_sidecar_1.voyageSystems_internalSensor.onLeave,
        onSelectedCrewOn: voyageSystems_internalSensor_sidecar_1.voyageSystems_internalSensor.onSelectedCrewOn,
        abbv: 'SI',
        name: 'Internal Sensors',
        infoText: 'Scan for anomalies inside the ship.',
    });
    register({
        type: EVoyageSystemType.SensorExternal,
        startsWith: 'sensor-external',
        crewUpdate: voyageSystems_externalSensor_sidecar_1.voyageSystems_externalSensor.crewUpdate,
        onLeave: voyageSystems_externalSensor_sidecar_1.voyageSystems_externalSensor.onLeave,
        onSelectedCrewOn: voyageSystems_externalSensor_sidecar_1.voyageSystems_externalSensor.onSelectedCrewOn,
        abbv: 'SE',
        name: 'External Sensors',
        infoText: 'Scan for anomalies ouside the ship using radar, lidar, and truthdar.',
    });
    register({
        startsWith: 'med',
        crewUpdate: voyageSystems_med_sidecar_1.voyageSystems_med.crewUpdate,
        abbv: 'M',
        abbvXAdjust: -3,
        name: 'Medical Station',
        infoText: 'Enable healing on the nearby Medical Pad.',
    });
    register({
        tileType: voyageTileData_1.EVoyageTile.MedPad,
        startsWith: 'pad',
        crewUpdate: voyageSystems_medPad_sidecar_1.voyageSystems_medPad.crewUpdate,
        name: 'Medical Pad',
        infoText: 'Stand here to heal, if there is a crewmember operating the nearby Medical Station.',
        killText: true,
    });
    register({
        tileType: voyageTileData_1.EVoyageTile.Elevator,
        startsWith: '',
        //crewUpdate: voyageSystems_med.crewUpdate,
        name: 'Elevator',
        infoText: 'Moves crew between different floors on the Dawn Star.',
        killText: true,
    });
    register({
        type: EVoyageSystemType.Reactor,
        startsWith: 'reactor',
        crewUpdate: voyageSystems_reactor_sidecar_1.voyageSystems_reactor.crewUpdate,
        onLeave: voyageSystems_reactor_sidecar_1.voyageSystems_reactor.onLeave,
        onSelectedCrewOn: voyageSystems_reactor_sidecar_1.voyageSystems_reactor.onSelectedCrewOn,
        allowMultiple: true,
        abbv: 'R',
        name: 'Reactor',
        infoText: 'Powers the ship, a critical component that you do not want to go critical.',
    });
    register({
        type: EVoyageSystemType.LifeSupport,
        startsWith: 'life-support',
        crewUpdate: voyageSystems_lifeSupport_sidecar_1.voyageSystems_lifeSupport.crewUpdate,
        onLeave: voyageSystems_lifeSupport_sidecar_1.voyageSystems_lifeSupport.onLeave,
        onSelectedCrewOn: voyageSystems_lifeSupport_sidecar_1.voyageSystems_lifeSupport.onSelectedCrewOn,
        allowMultiple: true,
        abbv: 'LS',
        name: 'Life Support',
        infoText: 'Supports life by providing oxygen to fragile crew members. Does not help robots.',
    });
    register({
        startsWith: 'crematorium',
        crewUpdate: voyageSystems_crematorium_sidecar_1.voyageSystems_crematorium.crewUpdate,
        abbv: 'CM',
        name: 'Crematorium',
        abbvXAdjust: -3,
        infoText: 'In space, no one can hear you scream.\n\nTrying to find a safe way to dispose of dead bodies?\n\nIn space, no one can. Here, use crematorium.\n\nWarning: starts corpses on fire!',
    });
    register({
        startsWith: 'laser',
        crewUpdate: voyageSystems_laser_sidecar_1.voyageSystems_laser.crewUpdate,
        networkProcessWeaponCommand: voyageSystems_laser_sidecar_1.voyageSystems_laser.networkProcessWeaponCommand,
        abbv: 'L',
        name: 'Laser Cannon',
        infoText: 'Fast and easy to use laser cannon (tm). Beware, it takes quite a toll on the ship power.',
    });
    register({
        startsWith: 'torpedo',
        crewUpdate: voyageSystems_torpedo_sidecar_1.voyageSystems_torpedo.crewUpdate,
        networkProcessWeaponCommand: voyageSystems_torpedo_sidecar_1.voyageSystems_torpedo.networkProcessWeaponCommand,
        abbv: 'T',
        name: 'Torpedo Launcher',
        infoText: 'Fire highly explosive torpedoes. Rumors about the ammunition being highly-refined potatoes are unfounded. Requires a crew to first load a torpedo in the nearby Torpedo Loader.',
        extraInfo: function (t) {
            if (t.system) {
                if (t.system.ammo === 0) {
                    return 'No torpedo is loaded';
                }
                else {
                    return ('Contains ' +
                        t.system.ammo +
                        ' fully-armed torpedo' +
                        (t.system.ammo === 1 ? '' : 's'));
                }
            }
            return '?';
        },
    });
    register({
        type: EVoyageSystemType.TorpedoLoader,
        startsWith: 'loader',
        crewUpdate: voyageSystems_torpedoLoader_sidecar_1.voyageSystems_torpedoLoader.crewUpdate,
        onLeave: voyageSystems_torpedoLoader_sidecar_1.voyageSystems_torpedoLoader.onLeave,
        onSelectedCrewOn: voyageSystems_torpedoLoader_sidecar_1.voyageSystems_torpedoLoader.onSelectedCrewOn,
        abbv: 'TL',
        name: 'Torpedo Loader',
        infoText: 'Careful! These things are expensive and heavy. Load a highly-refined potato-based exposive into the nearby Torpedo Launcher tube.',
    });
    register({
        startsWith: 'bed',
        crewUpdate: voyageSystems_bed_sidecar_1.voyageSystems_bed.crewUpdate,
        abbv: 'B',
        name: 'Bed',
        infoText: 'If you do not know what one of these are for, you are probably an alien impostor.',
        allowMultiple: true,
        frame: sprites_sidecar_1.sprites.voyTileBed[0],
        killText: true,
        killImage: true,
    });
    register({
        startsWith: 'captain',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        abbv: 'C',
        name: 'The Chair of the Captain',
        infoText: 'Does not do much but it sure looks comfortable.',
    });
    register({
        startsWith: 'galley',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        abbv: 'G',
    });
    register({
        startsWith: 'engine',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        abbv: 'E',
    });
    register({
        startsWith: 'shield',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        abbv: 'S',
    });
    register({
        type: EVoyageSystemType.Nav,
        startsWith: 'nav',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        onEnter: voyageSystems_nav_sidecar_1.voyageSystems_nav.onEnter,
        onLeave: voyageSystems_nav_sidecar_1.voyageSystems_nav.onLeave,
        onSelectedCrewOn: voyageSystems_nav_sidecar_1.voyageSystems_nav.onSelectedCrewOn,
        name: 'Nav',
        abbv: 'N',
        abbvXAdjust: -2,
        infoText: 'Plot a course to a new destination',
    });
    register({
        type: EVoyageSystemType.Coms,
        startsWith: 'coms',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        onEnter: voyageSystems_coms_sidecar_1.voyageSystems_coms.onEnter,
        onLeave: voyageSystems_coms_sidecar_1.voyageSystems_coms.onLeave,
        onSelectedCrewOn: voyageSystems_coms_sidecar_1.voyageSystems_coms.onSelectedCrewOn,
        name: 'Coms',
        abbv: 'CO',
        infoText: 'Order supplies and crew from nearby space stations',
        // abbvXAdjust: -2,
    });
    register({
        type: EVoyageSystemType.JumpDrive,
        startsWith: 'hyper',
        crewUpdate: voyageSystems_hyperdrive_sidecar_1.voyageSystems_hyperdrive.crewUpdate,
        onLeave: voyageSystems_hyperdrive_sidecar_1.voyageSystems_hyperdrive.onLeave,
        onSelectedCrewOn: voyageSystems_hyperdrive_sidecar_1.voyageSystems_hyperdrive.onSelectedCrewOn,
        //onEnter: voyageSystems_coms.onEnter,
        name: 'Hyper-X FTL Drive',
        abbv: 'XD',
        infoText: 'Charge so Nav can jump to a new location',
        // abbvXAdjust: -2,
    });
    register({
        startsWith: 'cargo',
        allowMultiple: true,
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        name: 'Cargo bay',
        abbv: 'CB',
        killText: true,
        frame: sprites_sidecar_1.sprites.voyTileSquareInv[0],
        tint: voyageColors_sidecar_1.voyageColors.purple,
        // abbvXAdjust: -2,
    });
    register({
        startsWith: 'tele',
        allowMultiple: true,
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        name: 'Teleporter',
        abbv: 'TP',
        frame: sprites_sidecar_1.sprites.voyTileSquareRounded[0],
        tint: voyageColors_sidecar_1.voyageColors.green,
        // abbvXAdjust: -2,
    });
    register({
        startsWith: 'loading',
        // crewUpdate: voyageSystems_torpedoLoader.crewUpdate,
        abbv: 'LB',
        name: 'Loading bay',
        infoText: '',
    });
    register({
        startsWith: 'coffe',
        onEnter: voyageSystems_coffeeMaker_sidecar_1.voyageSystems_coffeeMaker.onEnter,
        abbv: 'CF',
        name: 'Coffee Maker',
        frame: sprites_sidecar_1.sprites.voyItemCoffee[0],
        infoText: 'No self-respecting captain would leave on a multi-year journey without coffee!\n\nCoffee speeds up crewmembers who drink it.',
    });
    // register({
    //   startsWith: 'battlerifle',
    //   // crewUpdate: voyageSystems_coffeeMaker.crewUpdate,
    //   onEnter: voyageSystems_battleRifleRack.onEnter,
    //   abbv: 'BR',
    //   name: 'Battle Rifle Rack',
    //   startsWithAmmo: 3,
    //   infoText: 'Battle Rifles - for when you want aliens dead faster (TM)',
    //   extraInfo: (t) => {
    //     if (t.system) {
    //       if (t.system.ammo === 0) {
    //         return 'Is currently empty'
    //       } else {
    //         return (
    //           'Contains ' +
    //           t.system.ammo +
    //           ' battle rifle' +
    //           (t.system.ammo === 1 ? '' : 's')
    //         )
    //       }
    //     }
    //     return '?'
    //   },
    // })
    register({
        startsWith: 'rack',
        allowMultiple: true,
        // crewUpdate: voyageSystems_coffeeMaker.crewUpdate,
        onCreate: voyageSystems_rack_sidecar_1.voyageSystems_rack.onCreate,
        onEnter: voyageSystems_rack_sidecar_1.voyageSystems_rack.onEnter,
        abbv: 'R',
        name: 'Equipment Rack',
        startsWithAmmo: 3,
        infoText: 'General equipment storage. Move on to get or put equipment here.',
        killText: true,
        killImage: true,
        frame: sprites_sidecar_1.sprites.voyTileSquareRoundedOutline[0],
        tint: voyageColors_sidecar_1.voyageColors.purple,
        // extraInfo: (t) => {
        //   if (t.system) {
        //     if (t.system.ammo === 0) {
        //       return 'Is currently empty'
        //     } else {
        //       return (
        //         'Contains ' +
        //         t.system.ammo +
        //         ' battle rifle' +
        //         (t.system.ammo === 1 ? '' : 's')
        //       )
        //     }
        //   }
        //   return '?'
        // },
    });
    register({
        startsWith: 'ejector',
        allowMultiple: true,
        onEnter: voyageSystems_ejector_sidecar_1.voyageSystems_ejector.onEnter,
        abbv: 'EJ',
        name: 'Ejector',
        startsWithAmmo: 3,
        infoText: 'Place items here to jettison them',
    });
    register({
        startsWith: 'ejectrol',
        allowMultiple: true,
        crewUpdate: voyageSystems_ejectrol_sidecar_1.voyageSystems_ejectrol.crewUpdate,
        abbv: 'EC',
        name: 'Ejector control unit',
        startsWithAmmo: 3,
        infoText: 'Use to jettison items at the ejector.',
    });
    register({
        // Ejection point
        startsWith: 'ejp',
        abbv: 'EJP',
        killText: true,
        hide: true,
    });
    register({
        // Fire point
        startsWith: 'fp',
        abbv: 'FP',
        killText: true,
        hide: true,
    });
}
exports.registerAll = registerAll;
